import { NgModule } from '@angular/core';

import { MgOverlayStructureDirective } from './MgOverlayStructure.directive';

@NgModule({
  declarations: [MgOverlayStructureDirective],
  exports: [MgOverlayStructureDirective],
})
export class MgOverlayStructureModule {}
